import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center h-14 z-999" }
const _hoisted_2 = {
  key: 0,
  class: "items-center mt-4 mb-4 hidden md:block -ml-4.5 mr-8"
}
const _hoisted_3 = { class: "material-icons-outlined" }
const _hoisted_4 = { class: "flex items-center mr-auto" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center ml-4 md:ml-6"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "volunteer_activism", -1)
const _hoisted_9 = { class: "w-72 text-center" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { href: "https://paypal.me/bsamusp00?country.x=IT&locale.x=it_IT" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined" }, " help_outline ", -1)
const _hoisted_13 = { class: "py-4 px-2" }
const _hoisted_14 = { class: "items-center flex" }
const _hoisted_15 = { class: "flex flex-col -space-y-1.5" }
const _hoisted_16 = { class: "text-muted text-sm" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg material-icons-outlined" }, " logout ", -1)
const _hoisted_18 = {
  key: 1,
  class: "md:hidden"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-darkText" }, " menu ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_LocaleSelector = _resolveComponent("LocaleSelector")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("nav", {
    style: {"z-index":"1000"},
    class: _normalizeClass([{ sticky: _ctx.sticky }, "top-0 py-0.5 md:px-12 text-gray-700 bg-white px-2 shadow-elevation mx-auto sm:px-6 lg:px-8 w-full"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showCollapseSideBarButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Btn, {
              id: "toggle-sidebar",
              tooltip: !_ctx.sidebarCollapsed ? _ctx.$t('misc.unfix_sidebar') : _ctx.$t('misc.fix_sidebar'),
              variant: 'icon',
              outline: true,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebarCollapsed'))),
              class: "hidden md:block"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(!_ctx.sidebarCollapsed ? "menu_open" : "menu"), 1)
              ]),
              _: 1
            }, 8, ["tooltip"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          class: "lg:w-60 3xl:w-70 w-52 md:-ml-1",
          src: _ctx.logoUrl
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.metaStore.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (false && _ctx.showLocaleSelector)
                ? (_openBlock(), _createBlock(_component_LocaleSelector, {
                    key: 0,
                    class: "md:mr-0 -mr-2"
                  }))
                : _createCommentVNode("", true),
              (_ctx.isDemoMode)
                ? (_openBlock(), _createBlock(_component_DropdownMenu, {
                    key: 1,
                    placement: 'left',
                    class: "text-lightText",
                    expanded: _ctx.donateExpanded,
                    onToggleExpanded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onToggleDonate()))
                  }, {
                    icon: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("donate.donate_title")), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("donate.donate_content")), 1),
                        _createElementVNode("a", _hoisted_11, [
                          _createVNode(_component_Btn, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("donate.donate_now")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["expanded"]))
                : _createCommentVNode("", true),
              (_ctx.showHelpCenterButton)
                ? (_openBlock(), _createBlock(_component_Btn, {
                    key: 2,
                    tooltip: _ctx.$t('help.help_guide_label'),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.metaStore.setHelpCenterVisibility(true))),
                    id: "help-center",
                    variant: 'icon',
                    outline: true
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }, 8, ["tooltip"]))
                : _createCommentVNode("", true),
              _createVNode(_component_DropdownMenu, {
                placement: 'right',
                expanded: _ctx.donateExpanded,
                onToggleExpanded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onToggleDonate()))
              }, {
                activator: _withCtx(() => [
                  _createVNode(_component_Avatar, {
                    style: {"box-sizing":"content-box"},
                    class: "darken-on-hover cursor-pointer md:ml-4 mr-1 md:mr-2 border-transparent border-4 hover:border-gray-300 hover:border-opacity-60",
                    user: _ctx.metaStore.user
                  }, null, 8, ["user"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Avatar, {
                        size: 'xl',
                        class: "mr-4",
                        user: _ctx.metaStore.user
                      }, null, 8, ["user"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.metaStore.user.full_name), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.metaStore.user.email), 1)
                      ]),
                      _createVNode(_component_Btn, {
                        class: "ml-6",
                        tooltip: _ctx.$t('misc.logout'),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('logout'))),
                        variant: 'icon',
                        outline: true
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["tooltip"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["expanded"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showMobileSidebarButton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_Btn, {
              variant: 'icon',
              outline: true,
              class: "md:hidden",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('toggleMobileSidebar')))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}